import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import * as actions from './actions';
import { getConfig } from 'functions/getConfig';
import { useActions } from 'hooks/useActions';
import { Spinner } from 'components/Spinner/Spinner';
import { RankList } from 'components/CMSRankList/CMSRankList';
import { Button, LinkButton } from 'components/Button/RoundButton';
import { Container, Wrapper } from 'components/Layout/Layout';
import { Header, HeadingContainer } from 'components/PageTitleHeader/styles';
import { HeadingButtonContainer } from '../cmsAllChallenges/styles';
import { RankListContainer } from './styles';

export default React.memo(() => {
  const { contestId } = useParams();
  const [isActiveSession, setIsActiveSession] = useState(false);

  const { getContestForCMS, getRankList, runTournament, continuousRunningTournament } = useActions(actions);

  let { loading, contest, rankList, isSessionRunning } = useSelector((state) => state.CMSResultReducer);

  useEffect(() => {
    getContestForCMS(contestId);
  }, [getContestForCMS, contestId]);

  useEffect(() => {
    if (contest._id) getRankList(contestId, contest.isTournament ? true : false);
  }, [contest, contestId, getRankList]);

  useEffect(() => {
    if (isSessionRunning) toast.success('Cron has started');
    setIsActiveSession(isSessionRunning);
  }, [isSessionRunning]);

  return (
    <Wrapper padding="40px 0 0 0" minHeight="100vh">
      <Container full column>
        {loading && <Spinner />}
        {!loading && (
          <HeadingContainer>
            <Header>Rank List: {contest?.name}</Header>
            <HeadingButtonContainer>
              <LinkButton
                primaryBlue
                primaryGreenBorder
                removeMargin
                fontSize="12px"
                href={`${getConfig().REACT_URL}/cms/AllContests/${contest.test}`}
              >
                <i className="fa fa-arrow-left" style={{ marginRight: '5px' }}></i>All Contests
              </LinkButton>
              <Button
                primaryBlue
                primaryGreenBorder
                removeMargin
                fontSize="12px"
                disabled={!rankList.length}
                title={
                  isActiveSession && new Date(contest.continuousRunningUntil) > new Date()
                    ? 'After pressing stop the running session will still finish running. Might take a minute'
                    : 'Run for 1 hour'
                }
                onClick={() => {
                  continuousRunningTournament(contestId, { status: isActiveSession ? 'stop' : 'run' });
                  setIsActiveSession(true);
                  if (isActiveSession)
                    toast.success('The current session will be completed before the continuous run is stopped');
                }}
              >
                {isActiveSession && new Date(contest.continuousRunningUntil) > new Date()
                  ? 'Stop Continuous Running'
                  : 'Run Tournament for 1 hour'}
              </Button>
              <Button
                primaryBlue
                primaryGreenBorder
                removeMargin
                fontSize="12px"
                disabled={isActiveSession || !rankList.length}
                onClick={() => {
                  runTournament(contestId, { attempts: 5, roundCount: 5 });
                  setIsActiveSession(true);
                }}
              >
                Run Tournament
              </Button>
              <Button
                primaryBlue
                primaryGreenBorder
                removeMargin
                fontSize="12px"
                disabled={isActiveSession || !rankList.length}
                onClick={() => {
                  runTournament(contestId, { attempts: 5, roundCount: 5, rankedMatching: true });
                  setIsActiveSession(true);
                }}
              >
                Run Tournament v2
              </Button>
            </HeadingButtonContainer>
          </HeadingContainer>
        )}
        <RankListContainer>
          {rankList.length > 0 && (
            <RankList isTournament={contest.isTournament} contestId={contestId} rankList={rankList} />
          )}
        </RankListContainer>
      </Container>
    </Wrapper>
  );
});
